import { raiseUnreachable } from '@weft/utils';
import React from 'react';
import { twMerge } from 'tailwind-merge';
import type { ButtonProps } from './button-types/button-props';
import type { ButtonVariant } from './button-types/button-variant';
import { BUTTON_VARIANTS } from './button-types/button-variant';

export const Button: React.FC<ButtonProps> = ({ variant = BUTTON_VARIANTS.contained, className: externalClassName, children, ...props }) => {
  const className = useButtonStyle(variant, { ...props, className: externalClassName, variant, children });

  return (
    <button
      className={className}
      {...props}
    >
      {children}
    </button>
  );
};

function useButtonStyle(variant: ButtonVariant, props: ButtonProps) {
  switch (variant) {
    case BUTTON_VARIANTS.contained:
      return twMerge(
        'bg-btn-gradient-green box-shadow-btn-gradient-green text-black py-3 px-6.5 border-0 shadow-lg text-lg font-medium h-[unset] rounded-0md font-sans hover:!text-black',
        `${!props.disabled ? 'hover:bg-btn-gradient-green-hover hover:box-shadow-btn-gradient-green-hover' : 'opacity-50'}`,
        props.className,
      );
    case BUTTON_VARIANTS.text:
      return twMerge(
        props.disabled ? 'opacity-50' : 'text-btn-gradient-green',
        props.className,
      );
    default:
      return raiseUnreachable(variant);
  }
}